/**
 * Field-to-Mapping Registry
 *
 * Maps field names (or patterns) to their value label mappings.
 * Used by formatCampaignValue to automatically apply the correct mapping.
 *
 * NOTE: Both snake_case and camelCase versions are included because:
 * - The backend API returns snake_case field names (e.g., restart_mode)
 * - Some frontend code may use camelCase versions (e.g., restartMode)
 * - This ensures consistent label display regardless of the source format
 */

import {
  ActionStateLabels,
  ActionSubTypeLabels,
  ActionTypeLabels,
  ExitTypeLabels,
  PlatformLabels,
  SendingStateLabels,
  SplitStateLabels,
} from './action-types';
import {
  AudienceSettingsTypeLabels,
  CampaignStateLabels,
  CampaignTypeLabels,
  CampaignUpdateTypeLabels,
  ConversionActionLabels,
  ConversionTimeframeLabels,
  ConversionTypeLabels,
  DateTriggeredFrequencyLabels,
  ObjectRelationshipTriggerTypeLabels,
  ObjectTriggerTypeLabels,
  RestartModeLabels,
} from './campaign-types';
import { NewsletterChannelLabels, NewsletterTestMetricLabels } from '../newsletter-mapping';

export const FIELD_VALUE_MAPPINGS: Record<string, Record<string, string>> = {
  // Campaign fields (snake_case from API, camelCase for frontend compatibility)
  type: CampaignTypeLabels,
  state: CampaignStateLabels,
  restart_mode: RestartModeLabels,
  restartMode: RestartModeLabels,
  conversion_type: ConversionTypeLabels,
  conversionType: ConversionTypeLabels,
  conversion_action: ConversionActionLabels,
  conversionAction: ConversionActionLabels,
  conversion_timeframe: ConversionTimeframeLabels,
  conversionTimeframe: ConversionTimeframeLabels,
  date_triggered_frequency: DateTriggeredFrequencyLabels,
  dateTriggeredFrequency: DateTriggeredFrequencyLabels,
  update_type: CampaignUpdateTypeLabels,
  updateType: CampaignUpdateTypeLabels,

  // Action fields (snake_case from API, camelCase for frontend compatibility)
  // Note: 'type' field in CampaignAction context is handled specially in formatCampaignValue()
  // to distinguish between CampaignType (for Campaign) and ActionType (for CampaignAction)
  action_type: ActionTypeLabels,
  actionType: ActionTypeLabels,
  sub_type: ActionSubTypeLabels,
  subType: ActionSubTypeLabels,
  sending_state: SendingStateLabels,
  sendingState: SendingStateLabels,
  exit_type: ExitTypeLabels,
  exitType: ExitTypeLabels,
  action_state: ActionStateLabels,
  actionState: ActionStateLabels,
  split_state: SplitStateLabels,
  splitState: SplitStateLabels,
  send_to_platform: PlatformLabels,
  sendToPlatform: PlatformLabels,

  // Object campaign fields
  'objectCampaign.type': ObjectTriggerTypeLabels,
  'relationshipCampaign.type': ObjectRelationshipTriggerTypeLabels,
  'audience.type': AudienceSettingsTypeLabels,

  // Newsletter fields
  channel: NewsletterChannelLabels,
  test_metric: NewsletterTestMetricLabels,
  testMetric: NewsletterTestMetricLabels,
  platform: PlatformLabels,
};
